export const createGetWorkspacesRequest = () => {
  return {
    url: "/workspaces",
    method: "GET",
  };
};

export const createGetWorkspaceDetailsRequest = (id) => {
  return {
    url: `/workspaces/${id}`,
    method: "GET",
  };
};

export const createWorkspaceCreateRequest = (workspace) => {
  return {
    url: "/workspaces",
    method: "POST",
    data: workspace,
  };
};

export const createUpdateWorkspaceNameRequest = (id, name) => {
  return {
    url: `/workspaces/${id}`,
    method: "PUT",
    data: {
      name,
    },
  };
};

export const createGetPlanDetailsRequest = (id) => {
  return {
    url: `/workspaces/${id}/plan`,
    method: "GET",
  };
};

export const createDeleteWorkspaceRequest = (id, name) => {
  return {
    url: `/workspaces/${id}`,
    method: "DELETE",
    data: {
      name,
    },
  };
};
